/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Permissions_DescriptionInputs */

const en_agent_authorization_permissions_description = /** @type {(inputs: Agent_Authorization_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These permissions apply only to this project. They do not give the Agent access to your account or other listings.`)
};

const zh_agent_authorization_permissions_description = /** @type {(inputs: Agent_Authorization_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些权限只适用于当前项目，不会让 Agent 访问你的账号或其他条目。`)
};

/**
* | output |
* | --- |
* | "These permissions apply only to this project. They do not give the Agent access to your account or other listings." |
*
* @param {Agent_Authorization_Permissions_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_permissions_description = /** @type {((inputs?: Agent_Authorization_Permissions_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Permissions_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_permissions_description(inputs)
	return zh_agent_authorization_permissions_description(inputs)
});
export { agent_authorization_permissions_description as "agent.authorization.permissions_description" }